import styled from 'styled-components';
import { Button } from '../Button';
import { ButtonVariants, type ButtonProps } from '../styles';

export type ToggleButtonProps = {
  selected: boolean;
  selectedVariant?: ButtonVariants;
  unselectedVariant?: ButtonVariants;
  /** Is part of a group, causes button to be dimmed */
  grouped?: boolean;
  /** Whether grouped toggle buttons should emit the legacy aria-selected attribute. */
  legacyAriaSelected?: boolean;
} & ButtonProps;

/** A selectable button (typically used for listings in ButtonGroup controls) */
export const ToggleButton = styled(
  ({
    selected,
    selectedVariant = ButtonVariants.Priority,
    unselectedVariant = ButtonVariants.Default,
    grouped = false,
    legacyAriaSelected = true,
    ...props
  }: ToggleButtonProps) => {
    const selectedProp = grouped
      ? legacyAriaSelected
        ? { 'aria-selected': selected }
        : {}
      : { 'aria-pressed': selected };
    return (
      <Button
        data-selected={selected}
        {...selectedProp}
        {...props}
        variant={selected ? selectedVariant : unselectedVariant}
      />
    );
  }
)``;
